import { AmicusFile } from "@/lib/conflix";
import { TableCell, TableRow } from "./ui/table";
import { Button } from "./ui/button";
import { Dialog, DialogTrigger, DialogDescription, DialogHeader, DialogTitle, DialogPortal } from "./ui/dialog";
import { DialogContent } from "@radix-ui/react-dialog";

function AmicusRow(props: { amicusFile: AmicusFile, setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>, setAmicusFile: React.Dispatch<React.SetStateAction<AmicusFile | null>> }) {
    return (
        <TableRow>
            <TableCell>{props.amicusFile.ShortFileName}</TableCell>
            <TableCell>{props.amicusFile.PartyFirstName}</TableCell>
            <TableCell>{props.amicusFile.PartyLastName}</TableCell>
            <TableCell>{props.amicusFile.PartyCompanyName}</TableCell>
            <TableCell>{props.amicusFile.ResponsibleAttorneyFirstName}</TableCell>
            <TableCell>{props.amicusFile.ResponsibleAttorneyLastName}</TableCell>
            <TableCell>{new Date(props.amicusFile.FileCreatedOn).toLocaleString('en-US', { 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric'
            })}</TableCell>
            <TableCell>
                <Button variant="outline" onClick={() => { props.setAmicusFile(props.amicusFile); props.setDialogOpen(true); }}>More...</Button>
            </TableCell>
        </TableRow>
    )
}

export default AmicusRow;